module.exports = __webpack_public_path__ + "img/industry-6.88584e21.jpg";